const Data=[
    {   title:'Entertainment',
        desc:'From Hollywood blockbusters to indie gems, we bring you the latest news, reviews, and behind-the-scenes stories from the world of entertainment. Stay tuned for exclusive interviews and much more.',
        link:'entertainment.jpg'
    },
    {   title:'Finance',
        desc:'Stay informed with our in-depth analysis of financial markets, investment strategies, and economic trends. We provide expert insights to help you navigate the complexities of the financial world confidently.',
        link:'finance.jpg'
    },
    {   title:'Sports',
        desc:'Catch all the excitement from the world of sports with our comprehensive coverage of games, scores, and player profiles. Whether its football, basketball, or any other sport, we have got you covered.',
        link:'sports.jpg'
    },
    {   title:'Health and Wellness',
        desc:'Discover the best tips and advice for maintaining a healthy lifestyle. From fitness routines to nutritious recipes, our experts provide the guidance you need to achieve your health and wellness goals',
        link:'health.jpg'
    }
]

export default Data